export default __webpack_public_path__ + "static/media/GI.c5336f0c.svg";